import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as projects from '../../../../projects'
import * as innovationAsset from '../innovation-asset'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationAsset.RESOURCE.payload.dimension.partialId,
      partialId: innovationAsset.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Project that this asset was piloted on',
    isOptional: true,
    name: 'Pilot Project',
    partialId: PartialId.Standard.create('pilot_proj'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(projects.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
